<template>
  <div class="not-in-serve">
    <div
      class="region"
    >
      <div
        v-if="!hideTitle"
        class="region__title"
      >
        <h3>服務範圍</h3>
      </div>
      <div class="region__content">
        <div
          v-if="notLoggedIn"
          class="login"
        >
          <div class="login__desc red-desc">
            此服務僅提供給智生活社區住戶使用
          </div>
          <nuxt-link :to="{name: 'auth-action', params: {action: 'login'}, query: { redirect: $nuxt.$route.path }}">
            <v-btn
              btn-title="首頁"
              depressed
              color="primary"
              class="login__go-login"
            >
              前往登入
            </v-btn>
          </nuxt-link>
        </div>
        <div
          v-if="noCommunity"
          class="no-community"
        >
          <div
            class="no-community__desc red-desc"
          >
            此服務僅提供給智生活社區住戶使用<br>若您尚未開通社區請前往管理室開通
          </div>
          <div class="downloads">
            <a
              href="https://access.smartdaily.com.tw/launchApp.html?page=login"
              target="_blank"
              class="qrcode"
            >
              <img
                src="~/assets/image/qr-code.png"
                alt="app-qrcode"
              >
            </a>
            <div class="store">
              <a
                href="https://apps.apple.com/tw/app/id1071519372"
                target="_blank"
              >
                <img
                  src="~/assets/image/app-store.svg"
                  alt="app store 下載 智生活"
                >
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=chk.kingnet.app"
                target="_blank"
              >
                <img
                  src="~/assets/image/google-play.svg"
                  alt="google play 下載 智生活"
                >
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="noServiceCommunity"
          class="region__desc red-desc"
        >
          很抱歉，目前您所在的區域不在服務範圍內，我們正積極拓展中，期待不久後能為您提供便利的服務！
        </div>
        <div class="region__list">
          <div
            v-for="(city, cityIndex) in cityAreaList"
            :key="cityIndex"
            class="region__list-item"
          >
            <div class="region__list-item__city">
              {{ city.MainName }}
            </div>
            <div
              class="region__list-item__region-wrap"
            >
              <span
                v-for="(region, regionIndex) in city.AreaList"
                :key="regionIndex"
                class="region__list-item__region"
              >{{ region.ParentName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!notLoggedIn"
        class="region__footer"
      >
        <nuxt-link :to="{ name: 'home', params: { toTop: true }}">
          <v-btn
            btn-title="首頁"
            depressed
            color="primary"
          >
            返回首頁
          </v-btn>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    reason: {
      type: String,
      default: ''
    },
    cityAreaList: {
      type: Array,
      default: () => []
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    notLoggedIn () {
      return this.reason === 'notLoggedIn'
    },
    noCommunity () {
      return this.reason === 'noCommunity'
    },
    noServiceCommunity () {
      return this.reason === 'noServiceCommunity'
    }
  }
}
</script>
<style lang="scss" scoped>

.not-in-serve {
  background: $whiteColor;
  border-radius: 10px;
  max-width: 100%;
  padding: 0 24px;
}

.login {
  display: flex;
  place-items: center;
  flex-direction: column;
  gap: 24px;
  padding: 48px 0;

  &__desc {
    display: grid;
    place-items: center;
  }
}

.region {
  &__title {
    font-size: pxTorem(17px);
    font-weight: 600;
    border-bottom: 1px solid $semiGrayColor;
    display: grid;
    place-items: center;
    padding: 32px 0 15.5px 0;
  }

  &__desc {
    padding: 48px 0;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 64px;
  }

  &__list-item {
    font-size: pxTorem(17px);
    &__city {
      font-weight: 600;
    }

    &__region-wrap {
      margin-top: 8px;
    }
    &__region {
      &:not(:last-child)::after{
        content: '\00a0\00a0';
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
  }
}

.no-community {
  padding: 48px 0;
  &__desc {
    margin-bottom: 24px;
    display: grid;
    place-items: center;
  }
}

.downloads {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .store {
    margin-left: 15px;
    a {
      &:first-child {
        margin-bottom: 10px;
      }
    }
  }
  .qrcode {
    background-color: #fff;
    border-radius: 10px;
    img {
      max-height: 100px;
      width: auto;
    }
  }
  a {
    display: block;
  }
  img {
    display: block;
  }
}

.red-desc {
  color: $orangeColor;
  font-size: pxTorem(18px);
  font-weight: 600;
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .downloads {
    padding-top: 27px;
    padding-bottom: 27px;
    .qrcode {
      display: block;
      img {
        max-width: 150px;
        height: auto;
      }
    }
  }
}
</style>
